import { useFeatureFlag } from '@/integrations/feature-flags/feature-flags';
import { FEATURE_FLAGS } from '@erp/shared-types';

export function useIsOneToOneProductMapping(): boolean {
  const { enabled: oneToOneFlagEnabled } = useFeatureFlag(
    FEATURE_FLAGS['one-to-one-product-variant-mapping-enabled'],
    false,
  );

  return (
    oneToOneFlagEnabled ||
    window.location.hostname.toLowerCase().includes('videojet')
    // || Math.random() > 0 // hack for now to make work on local
  );
}
